export const RESET_REPORTS = 'RESET_REPORTS';
export const SUCCESS_GET_REPORTS = 'SUCCESS_GET_REPORTS';
export const FAILED_GET_REPORTS = 'FAILED_GET_REPORTS';



// WEBPACK FOOTER //
// src/state/constants/reportConstants.js